'use client'

import { useEffect, useRef } from 'react'

// ponytail: role/aria-modal/Escape/focus-restore only, no full focus trap;
// add trapping if real keyboard leaks show up in testing
export default function ModalDialog({ labelledById, onClose, className = '', style, children, ...rest }) {
  const shellRef = useRef(null)

  useEffect(() => {
    const previous = document.activeElement
    const shell = shellRef.current
    if (shell && shell !== document.activeElement && !shell.contains(document.activeElement)) {
      shell.focus()
    }
    if (!onClose) return undefined
    const onKey = (event) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
      if (previous && typeof previous.focus === 'function') previous.focus()
    }
  }, [onClose])

  return (
    <div
      ref={shellRef}
      className={className}
      role="dialog"
      aria-modal="true"
      aria-labelledby={labelledById}
      tabIndex={-1}
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', ...style }}
      {...rest}
    >
      {children}
    </div>
  )
}
